import { FC, SVGProps } from 'react'
import theme from 'theme'

type Props = SVGProps<SVGSVGElement>

const ToastCloseIcon: FC<Props> = ({ ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8052 11.8498C6.18675 8.36966 11.0653 3 11.0653 3C3.3429 3.89883 0.0134444 13.7858 6.27924 18.8791L6.3255 17.0584C7.52779 18.3952 9.00762 18.5104 9.00762 18.5104C8.05962 17.7268 8.05962 15.9753 8.05962 15.9753C9.58563 17.6807 11.2271 17.0584 11.2271 17.0584C9.30804 16.4362 9.44673 14.4772 9.44673 14.4772C12.7993 15.0533 12.6606 17.4041 12.6606 17.4041C11.5508 20.6998 7.66643 19.847 7.66643 19.847C12.3369 22.6816 18.6258 19.9852 20.4064 15.0763C22.2098 10.1905 19.759 4.33647 15.0191 5.4428C14.9035 4.40575 16.1057 3.57602 16.1057 3.57602C13.3775 4.45183 13.5624 5.74235 13.5624 5.74235L12.6144 4.49784L12.8456 6.59505L12.2676 9.03795C12.8225 10.7665 13.9092 10.2133 14.5797 8.8536C18.5799 8.09302 16.8919 14.5921 11.8051 11.8497L11.8052 11.8498Z"
      fill={theme.colors.surfaceContainerBackground}
    />
  </svg>
)

export default ToastCloseIcon
